import { inject, injectable } from "inversify";
import { action, computed, makeObservable, observable } from "mobx";
import { fromPromise, IPromiseBasedObservable } from "mobx-utils";
import { getJSON } from "@whatslly/commons/apiUtils";
import { FrontLogger } from "@whatslly/commons/frontLogger/frontLogger";
import type { IUserStore } from "@whatslly/ui-components/services/UserStore";
import { InjectUserStore } from "@whatslly/ui-components/services/UserStore";
import type { AiProvider } from "@whatslly/types/ai/llm";
import type { LLMModelsResponse } from "@whatslly/types/ai/LlmModelsRequest";
import { parseOrReturnError } from "../../../services/utils";

@injectable()
export class LlmProviderModalStore {
  loadModelsMap: Map<AiProvider, IPromiseBasedObservable<LLMModelsResponse>> = new Map();
  constructor(
    @inject(InjectUserStore) private readonly userStore: IUserStore,
    @inject(FrontLogger) private readonly logger: FrontLogger
  ) {
    makeObservable(this, {
      loadModelsMap: observable,
      loadModels: action,
    });
  }

  loadModels(provider: AiProvider) {
    if (!this.loadModelsMap.get(provider)) {
      this.loadModelsMap.set(
        provider,
        fromPromise(
          getJSON({
            urlSuffix: `/integrations/ai/models?provider=${provider}`,
            etoken: this.userStore.etoken ?? "",
          }).then((r) => parseOrReturnError<LLMModelsResponse>(r, this.logger))
        )
      );
    }
    return this.loadModelsMap.get(provider)!;
  }
}
